"use strict";
/**
 * 品牌类型 ID。
 *
 * 目的不是"多一层包装"，而是让 `getSite(tenantId)` 这类把两种 ID 传反的 bug
 * 在编译期就报错。多租户系统里 ID 传错一次的代价是数据串租户，不值得省这点类型噪音。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.toProductId = exports.toPageId = exports.toDomainId = exports.toUserId = exports.toSiteId = exports.toTenantId = void 0;
exports.isUuid = isUuid;
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function isUuid(value) {
    return UUID_RE.test(value);
}
function toBranded(kind, value) {
    if (!isUuid(value)) {
        // 尽早失败：把非法 ID 带进 SQL 只会变成一条难查的空结果
        throw new TypeError(`invalid ${kind}: ${JSON.stringify(value)}`);
    }
    return value;
}
const toTenantId = (v) => toBranded('TenantId', v);
exports.toTenantId = toTenantId;
const toSiteId = (v) => toBranded('SiteId', v);
exports.toSiteId = toSiteId;
const toUserId = (v) => toBranded('UserId', v);
exports.toUserId = toUserId;
const toDomainId = (v) => toBranded('DomainId', v);
exports.toDomainId = toDomainId;
const toPageId = (v) => toBranded('PageId', v);
exports.toPageId = toPageId;
const toProductId = (v) => toBranded('ProductId', v);
exports.toProductId = toProductId;
//# sourceMappingURL=ids.js.map